<template>
  <picture
    role="button"
    class="avatar-box"
    @click.stop="showMenuSidebar"
    :style="{backgroundImage: `url(${user.avatar})`}"
  >
  </picture>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    computed: {
      ...mapGetters('user', ['user'])
    },

    methods: {
      ...mapActions('slideSidebar', ['slideSidebarShow']),

      showMenuSidebar () {
        if (!this.$store.getters['user/user'].is_personal_infos_filled) {
          return null
        }

        this.slideSidebarShow({ name: 'UserMenuSidebar' })
      }
    }
  }
</script>


<style scoped lang="scss">
  .avatar-box {
    position: relative;
    border-radius: 100%;
    width: 36px;
    height: 36px;
    background-size: cover;
    background-position: center center;
  }
</style>